import React, { Component } from "react";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import Popup from "react-popup";

import $ from "jquery";
import { CustomSelect } from "../../../generico/Transferencia/Interbancarias/CustomSelect";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faSave} from "@fortawesome/free-solid-svg-icons";

export default class PopupAgreagrCuenta extends Component {

  constructor(props) {
    super(props);
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
    this.initData();
    this.state = {
      ...this.getInitialState(),
      errors: {},
    };
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    entidadNew: "",
    nroCuentaNew: "",
    nombreApellidoNew: "",
    tipoDocNew: "",
    tipoEntidadNew: "",
    documentoNew: "",
    hiddenNroCuenta: false,
    disabledEntidad: false,
    disabledTipoDoc: false,
    errors: {},
  });

  guardar() {
    TransferInterentidadService.addCuentaExterna(
      this.state.nombreApellidoNew,
      this.state.nroCuentaNew,
      this.state.tipoDocNew,
      this.state.documentoNew,
      this.state.entidadNew
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState(this.getInitialState());
          this.modalCuenta.click();
          this.props.addCuentaCallback("OK");
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
          this.props.addCuentaCallback("FAIL");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  validate = () => {
    const errors = {};
    if (!this.state.entidadNew) {
      errors.entidadNew = "Este campo es requerido";
    }
    if (!this.state.nroCuentaNew && !this.state.hiddenNroCuenta) {
      errors.nroCuentaNew = "Este campo es requerido";
    } else if (!this.state.hiddenNroCuenta && !/^[0-9]+$/.test(this.state.nroCuentaNew)) {
      errors.nroCuentaNew = "Favor ingrese un número válido, sin guión ni caracteres especiales";
    }
    if (!this.state.nombreApellidoNew) {
      errors.nombreApellidoNew = "Este campo es requerido";
    }
    if (!this.state.tipoDocNew) {
      errors.tipoDocNew = "Este campo es requerido";
    }
    if (!this.state.documentoNew) {
      errors.documentoNew = "Este campo es requerido";
    } else if (this.state.tipoDocNew === "3" && isNaN(Number(this.state.documentoNew))) {
      errors.documentoNew = "Sólo números para Cédula de Identidad";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  onChangeTipoEntidad = (tipoEntidadNew) => {

    if (tipoEntidadNew === "TARJETA DIMO") {
      this.setState({
        entidadNew: "1600",
        tipoEntidadNew,
        tipoDocNew: "3",
        nroCuentaNew: "",
        hiddenNroCuenta: true,
        disabledEntidad: true,
        disabledTipoDoc: true
      });
    } else {
      this.setState({
        entidadNew: "",
        tipoEntidadNew,
        hiddenNroCuenta: false,
        disabledEntidad: false,
        disabledTipoDoc: false
      });
    }

  }

  render() {

    let listEntidades = this.props.items.filter((item) => item.nombreTipoEntidad === this.state.tipoEntidadNew);

    const listTiposDocumentos = this.props.tipos.map((elemento) => (
      <option key={elemento.id} value={elemento.id}>
        {elemento.descripcion}
      </option>
    ));

    listTiposDocumentos.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    const { errors } = this.state;
    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
          if (this.validate()) {
            this.guardar();
          }
        }}
      >
        <div
          className="modal fade"
          id="modal-cuenta"
          data-backdrop="false"
        >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Datos de la Cuenta</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <CustomSelect
                      label={"Tipo Entidades *"}
                      name={"tipoEntidadNew"}
                      value={this.state.tipoEntidadNew}
                      itemList={this.props.tipoEntidadList}
                      onChangeItem={this.onChangeTipoEntidad}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomSelect
                      label={"Entidades"}
                      name={"entidadNew"}
                      value={this.state.entidadNew}
                      disabled={this.state.disabledEntidad}
                      itemList={listEntidades}
                      onChangeItem={(selectedOption) => {
                        this.setState({ entidadNew: selectedOption });
                      }}
                    />
                  </div>
                  <div className="col-12" hidden={this.state.hiddenNroCuenta}>
                    <div className="form-group">
                      <label className="input-label">Nro. de Cuenta</label>
                      <input
                        placeholder="Ingresar sin guiones (-) o barras (/)"
                        name="nroCuentaNew"
                        value={this.state.nroCuentaNew}
                        type="number"
                        className={`input-box form-control${errors.nroCuentaNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({ nroCuentaNew: val.target.value });
                        }}
                      />
                      {errors.nroCuentaNew && <span className="invalid-feedback d-block">{errors.nroCuentaNew}</span>}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nombre y Apellido</label>
                      <input
                        name="nombreApellidoNew"
                        value={this.state.nombreApellidoNew}
                        type="text"
                        className={`input-box form-control${errors.nombreApellidoNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({
                            nombreApellidoNew: val.target.value.toUpperCase(),
                          });
                        }}
                      />
                      {errors.nombreApellidoNew && <span className="invalid-feedback d-block">{errors.nombreApellidoNew}</span>}
                    </div>
                  </div>
                  <div className="col-12">
                    <CustomSelect
                      label={"Tipo de Documento"}
                      name={"tipoDocNew"}
                      value={this.state.tipoDocNew}
                      disabled={this.state.disabledTipoDoc}
                      itemList={this.props.tipos}
                      onChangeItem={(val) => {
                        this.setState({ tipoDocNew: val });
                      }}
                    />
                    {errors.tipoDocNew && <span className="invalid-feedback d-block">{errors.tipoDocNew}</span>}
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Documento</label>
                      <input
                        name="documentoNew"
                        value={this.state.documentoNew}
                        type="text"
                        className={`input-box form-control${errors.documentoNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({ documentoNew: val.target.value });
                        }}
                      />
                      {errors.documentoNew && <span className="invalid-feedback d-block">{errors.documentoNew}</span>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                    <button
                  type="button"
                  className="btn btn-cu-quintary btn-consulta"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState(this.getInitialState());
                  }}
                >
                 <FontAwesomeIcon icon={faClose} /> Cerrar
                </button>
                    </div>
                    <div className="col-md-6">
                    <button
                  type="submit"
                  className="btn btn-cu-primary"
                >
                <FontAwesomeIcon icon={faSave}/>  Guardar
                </button>
                    </div>
                  </div>
                </div>
                
              
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="##"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form >
    );
  }
}
